import Product from '../Products/Product';
import { products } from '../../resource/Products';

function Recommend(props) {
  const { items } = props;
  const relatedProducts = products.filter((product) =>
    items.includes(product.id)
  );

  return (
    <div className="recommend__container">
      <div className="recommend__wrapper">
        <div className="recommend__title">
          <h2>이런 제품은 어떠세요?</h2>
        </div>
        <div className="recommend__content">
          <div className="recommend__content-wrapper row">
            {relatedProducts.map((product) => (
              <div key={product.id} className="recommend__content-individual">
                <Product product={product} selection={[]} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Recommend;
